export const icons = {
  icon_arrow_right: ['arrow-category-filter', 'svg'],
  icon_arrow_downward: ['arrow-more-works', 'svg'],
  icon_try_on_black: ['try-on.black', 'svg'],
  icon_try_on_dark: ['try-on.dark', 'svg'],
  icon_try_on_light: ['try-on.light', 'svg'],
  icon_try_on_white: ['try-on.white', 'svg'],
  icon_home_light: ['home.light', 'svg'],
  icon_home_dark: ['home.dark', 'svg'],
  icon_product_indicator: ['border-radius-transparent', 'png'],
  icon_product_loading: ['sku-loading', 'png'],
  icon_camera: ['camera', 'svg'],
  icon_countdown: ['countdown', 'svg'],
  icon_cross: ['cross', 'svg']
} as const
export const alertIcons = {
  icon_camera_failed: 'camera-failed',
  icon_net_err: 'neterr',
  icon_err: 'error'
} as const

export const posters = {
  coco_style_banner: ['coco_style', 'banner'],
  total_look_cover: ['total_look', 'cover'],
  total_look_banner: ['total_look', 'banner'],
  mini_but_many_cover: ['mini_but_many', 'cover'],
  mini_but_many_banner: ['mini_but_many', 'banner'],
  all_for_one_cover: ['all_for_one', 'cover'],
  all_for_one_banner: ['all_for_one', 'banner'],
  triple_crush_cover: ['triple_crush', 'cover'],
  triple_crush_banner: ['triple_crush', 'banner']
} as const

export type IconName = keyof typeof icons
export type AlertIconName = keyof typeof alertIcons
export type PosterName = keyof typeof posters
